"use client"

import { CopySlash } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CopySlashIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CopySlashIcon = component(Icon)({ as: CopySlash })
